import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DfmDesignSystemModule, DfmDataTableModule } from 'diflexmo-angular-design';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DestroyableComponent } from './components/destroyable.component';

@NgModule({
  declarations: [DestroyableComponent],
  imports: [CommonModule, DfmDesignSystemModule, ReactiveFormsModule, DfmDataTableModule, MatProgressBarModule],
  exports: [DfmDesignSystemModule, DfmDataTableModule, MatProgressBarModule, CommonModule, ReactiveFormsModule],
  providers: [],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
